import React, { Component } from 'react';
import API from '../../../../api/api';
import queryString from 'query-string';
import Loading from '../../../../page/components/loading/loading';
import './details.less';
import Header from '../../components/header/header';
import TimeInterval from '../../components/timeInterval/timeInterval';
import DocumentTitle from 'react-document-title';
import zhCN from 'antd/es/locale/zh_CN';
import {
    Select,
    Input,
    Pagination,
    Table,
    Button,
    ConfigProvider
} from 'antd';
const { Option } = Select;


class DonateDetails extends Component {
    constructor(props) {
        super(props);

        this.chooseDateRange = this.chooseDateRange.bind(this);
        this.clearTime = this.clearTime.bind(this);
    };
    state = {
        data: '',
        columns: [
            // userId
            {
                title: '用户ID',
                dataIndex: 'userId',
                key: 'userId',
            },
            // userPhone
            {
                title: '手机号',
                dataIndex: 'userPhone',
                key: 'userPhone',
            },
            // registerIp
            {
                title: 'IP地址',
                dataIndex: 'registerIp',
                key: 'registerIp',
            },
            // userNick
            {
                title: '昵称',
                key: 'userNick',
                dataIndex: 'userNick',
            },
            // userName
            {
                title: '姓名',
                key: 'userName',
                dataIndex: 'userName',
            },
            // joinTime
            {
                title: '参与时间',
                key: 'joinTime',
                dataIndex: 'joinTime',
            },
            // registerTime
            {
                title: '注册时间',
                key: 'registerTime',
                dataIndex: 'registerTime',
            },
            // signinTime
            {
                title: '打卡时间',
                key: 'signinTime',
                dataIndex: 'signinTime',
            },
            // sendTime
            {
                title: '奖品发放时间',
                key: 'sendTime',
                dataIndex: 'sendTime',
            },
            // couponName
            {
                title: '奖品名称',
                key: 'couponName',
                dataIndex: 'couponName',
            },
            // consumeTime
            {
                title: '核销时间',
                key: 'consumeTime',
                dataIndex: 'consumeTime',
            },
            // jobUnit
            {
                title: '工作单位',
                key: 'jobUnit',
                dataIndex: 'jobUnit',
            },
            // position
            {
                title: '职位',
                key: 'position',
                dataIndex: 'position',
            },
            // isSafe
            {
                title: '风控状态',
                key: 'isSafe',
                dataIndex: 'isSafe',
            },
            // riskReason
            {
                title: '风控异常原因',
                key: 'riskReason',
                dataIndex: 'riskReason',
            },
            // consumeCode
            {
                title: '核销码',
                key: 'consumeCode',
                dataIndex: 'consumeCode',
            },
        ],
        error: '',
        date: null,
        selectData: {
            city: '全部',
            cityId: '0',
            base: '',
            baseId: '',
            risk: '全部',
            riskId: '0',
        },
        // 风险控制
        selectRiskData: [
            {
                name: '全部',
                id: '0',
            },
            {
                name: '风控正常',
                id: '1',
            },
            {
                name: '风控异常',
                id: '2',
            }
        ],
        // 基地选择数据
        selectListBase: null,
        selectListData: [],
        citySelectStatus: false,
        baseSelectStatus: false,
        downloadApi: window.location.origin + '/promotion/v1/playConsume/consumeExport',
        downloadUrl: '',
        selectBaseData: [],
    };
    // 更新下载链接
    updateDownloadUrl() {
        const {
            downloadApi,
            apiData,
        } = this.state;
        var url = downloadApi + "?companyCode=" + apiData.companyCode;
        if (apiData.queryCompany) {
            url += '&queryCompany=' + apiData.queryCompany;
        }
        if (apiData.queryStation) {
            url += '&queryStation=' + apiData.queryStation;
        }
        this.setState({ downloadUrl: url });

    }
    getCompanyCodeType() {
        const { companyCode } = this.state;
        if (companyCode.indexOf('F') == 0) {
            return "0";
        }
        else if (companyCode.indexOf('S') == 0) {
            return "1";
        }
        else {
            return "2";
        }
    }
    // 根据一级更新二级
    setSelectBaseData(type, data, companyList) {
        const {
            selectListData,
            selectData,
            selectId,
            companyCode,
            isSafe,
            selectRiskData,
            downloadUrl,
        } = this.state;
        // 设置风控级别默认选项
        if (isSafe || isSafe == 0) {
            for (var i in selectRiskData) {
                if (selectRiskData[i].id == isSafe) {
                    selectData.risk = selectRiskData[i].name;
                    selectData.riskId = selectRiskData[i].id;
                }
            }
        }
        // 获取权限对应级别
        var companyCodeType = this.getCompanyCodeType();
        switch (companyCodeType) {
            case "0":
                this.setState({
                    citySelectStatus: false,
                    baseSelectStatus: false,
                });
                break;
            case "1":
                this.setState({
                    citySelectStatus: true,
                });
                break;
            case "2":
                this.setState({
                    citySelectStatus: true,
                    baseSelectStatus: true,
                });
                break;
            default:
                this.setState({
                    citySelectStatus: false,
                    baseSelectStatus: false,
                });
                break;
        }

        var selectBaseData = [
            {
                companyDesc: '全部',
                companyCode: 0,
            }
        ];
        if (type == '0') {
            selectData.city = "全部";
            selectData.cityId = companyCode;
            selectData.base = "全部";
            selectData.baseId = 0;
        } else if (type == '1') {
            selectData.city = data.companyDesc;
            selectData.cityId = data.companyCode;
            selectData.base = "全部";
            selectData.baseId = 0;
            selectBaseData = data.companyList;
        } else if (type == '2') {
            selectData.city = data.companyDesc;
            selectData.cityId = data.companyCode;
            selectData.base = companyList.companyDesc;
            selectData.baseId = companyList.companyCode;
            selectBaseData = data.companyList;
        }
        this.setState({
            selectData: selectData,
            selectBaseData: selectBaseData,
        }, () => {
            this.updateDownloadUrl(); // 更新下载链接
        });
    }



    componentDidMount() {
        window.scrollTo(0, 0);
        let companyList = JSON.parse(localStorage.getItem('companyList'))
        let selectListData = companyList[0].companyList;
        selectListData.map(item => {
            let obj = { companyCode: 0, companyDesc: '全部' }
            item.companyList.unshift(obj)
        })
        let firstCode = companyList[0];
        delete (firstCode.companyList);
        selectListData.unshift(firstCode)
        const parsed = queryString.parse(window.location.search);
        if (!parsed.companyCode) {
            return;
        }
        var apiData = {
            companyCode: parsed.companyCode,
            pageNum: 1,
            pageCount: 10,
        };
        if (parsed.isSafe) {
            apiData.isSafe = parsed.isSafe;
        }
        this.setState({
            selectListData,
            isSafe: parsed.isSafe ? parsed.isSafe : false,
            apiData: apiData,
            downloadApi: parsed.downloadApi ? parsed.downloadApi : this.state.downloadApi,
            companyCode: parsed.companyCode,
            selectId: parsed.id ? parsed.id : parsed.companyCode,
        }, () => {
            //  处理默认下拉框数据
            this.setSelectDefaultData();
        });
    }
    // 获取对应id
    setSelectDefaultData() {
        const { selectListData, apiData, selectId, selectData } = this.state;
        if (selectId.indexOf('F') == 0) {
            this.setSelectBaseData('0');
            this.getPlayConsumeConsumeQueryData();
            return;
        }
        for (var i in selectListData) {
            if (selectListData[i].companyCode == selectId) {
                apiData.queryCompany = selectId;
                console.log(selectListData[i])
                this.setSelectBaseData('1', selectListData[i]);

                break;
            }
            if (selectListData[i].companyList) {
                for (var k in selectListData[i].companyList) {
                    if (selectListData[i].companyList[k].companyCode == selectId) {
                        apiData.queryCompany = selectListData[i].companyCode;
                        apiData.queryStation = selectId;
                        this.setSelectBaseData('2', selectListData[i], selectListData[i].companyList[k]);
                        break;
                    }
                }
            }
        }
        this.setState({ apiData }, () => {
            this.getPlayConsumeConsumeQueryData();
            this.updateDownloadUrl();   // 更新下载链接
        });
    }
    // 获取数据
    getPlayConsumeConsumeQueryData = async () => {
        const { selectId, apiData } = this.state;
        let result = await API.getPlayConsumeConsumeQueryApi(apiData);
        if (!result) return
        if (result.status == 1) {
            var newData = result.data;
            if (newData.consumeDataList && newData.consumeDataList.length > 0) {
                for (var i in newData.consumeDataList) {
                    newData.consumeDataList[i].key = newData.consumeDataList[i].joinTime;
                    if (newData.consumeDataList[i].isSafe == "0") {
                        newData.consumeDataList[i].isSafe = "";
                    } else if (newData.consumeDataList[i].isSafe == "1") {
                        newData.consumeDataList[i].isSafe = "正常";
                    } else if (newData.consumeDataList[i].isSafe == "2") {
                        newData.consumeDataList[i].isSafe = "异常";
                    }
                }
            } else {
                newData.consumeDataList = [];
            }
            this.setState({ data: newData });
            return
        }
        this.setState({ error: result.msg })
    }

    // 一级别下拉框选择数据
    handleProvinceChange(value) {
        console.log('一级下拉框value', value)
        const { selectListData, selectData, apiData } = this.state;
        if (value.indexOf('F') == '0') {
            this.setSelectBaseData('0');
            delete (apiData.queryCompany);
            delete (apiData.queryStation);
            this.setState({ apiData }, () => {
                this.updateDownloadUrl(); // 更新下载链接
            });
        }
        if (value != selectData.cityId) {
            for (var k in selectListData) {
                if (selectListData[k].companyCode == value && selectListData[k].companyList) {
                    selectData.city = selectListData[k].companyDesc;
                    selectData.cityId = selectListData[k].companyCode;
                    selectData.base = selectListData[k].companyList[0].companyDesc;
                    selectData.baseId = selectListData[k].companyList[0].companyCode;
                    apiData.queryCompany = selectListData[k].companyCode;
                    delete (apiData.queryStation);
                    this.setState({
                        apiData: apiData,
                        selectData: selectData,
                        selectBaseData: selectListData[k].companyList
                    }, () => {
                        this.updateDownloadUrl(); // 更新下载链接
                    });
                    break;
                }
            }
        }
    };
    // 二级别下拉框选择数据
    onSecondCityChange(value) {
        const { selectBaseData, selectData, apiData } = this.state;
        if (value != selectData.baseId) {
            for (var k in selectBaseData) {
                if (selectBaseData[k].companyCode == value) {
                    selectData.base = selectBaseData[k].companyDesc;
                    selectData.baseId = selectBaseData[k].companyCode;
                    if (value == '0') {
                        delete (apiData.queryStation);
                    } else {
                        apiData.queryStation = value;
                    }
                    this.setState({
                        apiData: apiData,
                        selectData: selectData,
                    }, () => {
                        this.updateDownloadUrl(); // 更新下载链接
                    });
                    break;
                }
            }
        }
    };
    // 风控选择结果
    riskChange(value) {
        const { selectRiskData, selectData, apiData } = this.state;
        if (value == '0') {
            selectData.risk = "全部";
            selectData.riskId = "0";
            delete (apiData.isSafe);
        } else if (selectData.riskId != value) {
            apiData.isSafe = value;
            for (var i in selectRiskData) {
                if (selectRiskData[i].id == value) {
                    selectData.risk = selectRiskData[i].name;
                    selectData.riskId = selectRiskData[i].id;
                    break;
                }
            }
        }
        this.setState({
            apiData: apiData,
            selectData: selectData,
        });

    }
    // 分页选择
    pageChange(pageNumber, pageSize) {
        const { apiData } = this.state;
        if (pageNumber != apiData.pageNum) {
            apiData.pageNum = pageNumber
            this.setState({ apiData }, () => {
                this.getPlayConsumeConsumeQueryData();
            });
        }
    }
    // 每页展示多少个
    onShowSizeChange(current, size) {
        const { apiData } = this.state;
        if (size != apiData.pageCount) {
            apiData.pageCount = size;
            apiData.pageNum = 1;
            this.setState({ apiData }, () => {
                this.getPlayConsumeConsumeQueryData();
            });
        }
    }
    // 清空时间
    clearTime() {
        const { apiData } = this.state;
        if (apiData.startTime) {
            delete (apiData.startTime);
        }
        if (apiData.endTime) {
            delete (apiData.endTime);
        }
        this.setState({ apiData });
    }
    // 选额时间回调
    chooseDateRange(timeData) {
        const { apiData } = this.state;
        apiData.startTime = timeData.startTime;
        apiData.endTime = timeData.endTime;
        this.setState({ apiData });
    }
    // 核销码回调
    consumeCodeFun(e) {
        var value = e.target.value.trim();
        const { apiData } = this.state;
        if (value) {
            apiData.consumeCode = value;
        } else {
            delete (apiData.consumeCode)
        }
        this.setState({ apiData });
    }
    // 提交数据
    submitFun() {
        const { apiData } = this.state;
        apiData.pageNum = 1;
        this.setState({ apiData }, () => {
            this.getPlayConsumeConsumeQueryData();
        });
    }


    render() {
        if (!this.state.data) {
            return <Loading></Loading>
        }
        const {
            data,
            listData,
            secondCity,
            columns,
            selectListData,
            selectData,
            selectBaseData,
            citySelectStatus,
            baseSelectStatus,
            selectRiskData,
            apiData,
            downloadUrl,
        } = this.state;
        const {
            consumeDataList,
            totalConsumeNum,
            totalRiskNum,
            totalConsumeAmount,
            totalRiskAmount,
            maxPageNum,
            curPageNum
        } = data;
        return (
            <DocumentTitle title="查询详情">
                <ConfigProvider locale={zhCN}>
                    <div className="donate-detail-tmp">
                        <Header roleName={'“铛铛合作方”核销查询系统 - ' + selectData.base} systemColor='#4574F4'></Header>
                        <div className="searh-condition">
                            {/* 选择框 */}
                            <div className="condition-one">
                                <Select
                                    defaultValue={selectData.cityId}
                                    value={selectData.cityId}
                                    disabled={citySelectStatus}
                                    style={{ width: 120 }}
                                    onChange={this.handleProvinceChange.bind(this)}
                                >
                                    {
                                        selectListData.map((val, index) => {
                                            return <Option value={val.companyCode} key={val.companyCode}>{val.companyDesc}</Option>
                                        })
                                    }
                                </Select>
                                <Select
                                    style={{ width: 120 }}
                                    defaultValue={selectData.baseId}
                                    value={selectData.baseId}
                                    disabled={baseSelectStatus}
                                    onChange={this.onSecondCityChange.bind(this)}
                                >
                                    {
                                        selectBaseData.map((val, index) => {
                                            return <Option value={val.companyCode} key={'selectBaseData' + val.companyCode}>{val.companyDesc}</Option>
                                        })
                                    }
                                </Select>
                                {/* 状态选择 */}
                                <Select
                                    defaultValue={selectData.riskId}
                                    value={selectData.riskId}
                                    style={{ width: 120 }}
                                    onChange={this.riskChange.bind(this)}
                                >
                                    {
                                        selectRiskData.map((val, index) => {
                                            return <Option value={val.id} key={val.id}>{val.name}</Option>
                                        })
                                    }
                                </Select>

                            </div>
                            {/* 核销码 */}
                            <Input placeholder="请输入核销码" className="search-code" onChange={this.consumeCodeFun.bind(this)} />

                            {/* 时间选择器 */}
                            <div className="time-tmp">
                                <TimeInterval
                                    className="timePicker"
                                    confirmCallback={this.chooseDateRange}
                                    clearTime={this.clearTime}
                                ></TimeInterval>
                            </div>
                            {/* 搜索按钮 */}
                            <div className="search-btn" onClick={this.submitFun.bind(this)}>搜索</div>
                            {/* 下载按钮 */}
                            <div className="down-btn">
                                <Button
                                    href={downloadUrl}
                                    type="primary"
                                    icon="download"
                                    size="default"
                                >下载核销表</Button>
                            </div>
                        </div>
                        {/* 数据列表 */}
                        <div className="hx-list">
                            <div className="risk-type">
                                <p className="totalConsumeNum"><i></i><span>总计核销数{totalConsumeNum}</span></p>
                                <p className="totalConsumeNum"><i></i><span>总计金额{totalConsumeAmount / 100}元</span></p>
                                <p className="totalRiskNum"><i></i><span>风控异常数{totalRiskNum}</span></p>
                                <p className="totalRiskNum"><i></i><span>风控异常金额{totalRiskAmount / 100}元</span></p>
                            </div>
                            {/* 数据列表 */}
                            <div className="list-box">
                                <Table
                                    pagination={false}
                                    bordered
                                    disabled
                                    columns={columns}
                                    dataSource={consumeDataList}
                                />
                            </div>
                            {/* 分页 */}
                            <div className="list-page" >
                                <Pagination
                                    defaultPageSize={apiData.pageCount}
                                    showQuickJumper
                                    showSizeChanger
                                    current={curPageNum}
                                    defaultCurrent={curPageNum}
                                    total={totalConsumeNum}
                                    pageSizeOptions={['10', '20', '30', '40', '50']}
                                    onShowSizeChange={this.onShowSizeChange.bind(this)}
                                    onChange={this.pageChange.bind(this)}
                                />
                            </div>
                        </div>
                    </div>
                </ConfigProvider>
            </DocumentTitle>
        )
    }

}

export default DonateDetails
